import { Directive, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[frodoDisableControl]',
})
export class DisableControlDirective {
  @Input() set frodoDisableControl(condition: boolean) {
    const action = condition ? 'disable' : 'enable';
    if (this?.ngControl?.control) {
      this.ngControl.control[action]();
    }
  }

  constructor(private ngControl: NgControl) {}
}
